import { render, staticRenderFns } from "./IconOrigamiBird.vue?vue&type=template&id=d1258486&scoped=true&"
var script = {}
import style0 from "./IconOrigamiBird.vue?vue&type=style&index=0&id=d1258486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1258486",
  null
  
)

export default component.exports